import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons';
import { IconDefinition } from '@fortawesome/pro-thin-svg-icons';
import { Box, Link } from '@mui/material';
import { FontIcon } from '@resurs-internal/mui';

import useTranslation from '../../hooks/useTranslation';
import { WizardPageAction } from '../../store/wizard/wizard';
import ProgressBar from '../ProgressBar/ProgressBar';
import VisibleOnDesktop from '../VisibleOnDesktop/VisibleOnDesktop';
import styles from './PagesHeader.styles';

type PagesHeaderProps = {
    actions: WizardPageAction[];
    onAction: (action: WizardPageAction) => Promise<boolean>;
    currentPage: number;
    currentSection: number;
    numberOfSections: number;
    numberOfPagesInSection: number;
    currentPageInSection: number;
    sectionTitle: string;
};

const PagesHeader = ({
    actions,
    onAction,
    currentPage,
    currentSection,
    numberOfSections,
    numberOfPagesInSection,
    sectionTitle,
    currentPageInSection,
}: PagesHeaderProps) => {
    const translate = useTranslation();
    return (
        <>
            {currentPage !== 0 && actions.indexOf('back') > -1 && (
                <>
                    <Box sx={styles.wizardHeaderBox}>
                        <Link
                            component="button"
                            color="secondary"
                            underline="none"
                            onClick={() => onAction('back')}
                            sx={(theme) => ({
                                fontWeight: 'bold',
                                color: theme.palette.grey[900],
                            })}>
                            <FontIcon icon={faChevronLeft as IconDefinition} size="xs" />{' '}
                            {translate('page.action.back')}
                        </Link>
                    </Box>
                </>
            )}
            <VisibleOnDesktop>
                {numberOfPagesInSection !== 0 && numberOfSections !== 0 && (
                    <ProgressBar
                        currentPage={currentPageInSection}
                        currentSection={currentSection}
                        totalSections={numberOfSections}
                        totalPagesInASection={numberOfPagesInSection}
                        sectionLabel={sectionTitle}
                    />
                )}
            </VisibleOnDesktop>
        </>
    );
};

export default PagesHeader;
